import React, { useEffect, useState } from "react";
import {
  Container,
  VStack,
  Heading,
  Text,
  FormControl,
  FormLabel,
  Input,
  Button,
  Center,
  Flex,
  Box,
} from "@chakra-ui/react";
import { colors } from "../../theme/index";
import { useDispatch } from "react-redux";
import { signUpUser } from "../../state";
import { useNavigate } from "react-router-dom";
import {
  useGoogleReCaptcha,
  GoogleReCaptchaProvider,
} from "react-google-recaptcha-v3";
import ErrorAlert from "../../components/ErrorAlert";
import SuccessAlert from "../../components/SuccessAlert";
import SendOtp from "./signUpApi/sendOTPApi";
const Login = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [rollNo, setRollNo] = useState("");
  const [recaptchaReady, setRecaptchaReady] = useState(false);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    if (executeRecaptcha) {
      setRecaptchaReady(true);
    }
  }, [executeRecaptcha]);

  useEffect(() => {
    const handleStatusChange = () => {
      setIsOnline(navigator.onLine);
    };
    window.addEventListener("online", handleStatusChange);
    window.addEventListener("offline", handleStatusChange);
    return () => {
      window.removeEventListener("online", handleStatusChange);
      window.removeEventListener("offline", handleStatusChange);
    };
  }, []);

  const handleContinue = async () => {
    setError("");
    setSuccessMessage("");

    if (!isOnline) {
      setError("Please connect to the internet.");
      return;
    }

    if (rollNo.length !== 9 || rollNo.replace(/[^0-9]/g, "").length !== 9) {
      setError("Invalid Roll Number");
      return;
    }

    if (!recaptchaReady || !executeRecaptcha) {
      setError("Recaptcha is not ready");
      return;
    }

    try {
      const reCaptchaToken = await executeRecaptcha();
      if (!rollNo || !reCaptchaToken) {
        setError("Please fill in all the fields.");
        return;
      }

      dispatch(signUpUser({ user_roll_no: rollNo }));
      const response = await SendOtp(rollNo, reCaptchaToken);
      if (response.status === 200) {
        // OTP sent successfully
        const { message } = response.data.message;
        // console.log(message);

        if (response.data.message === "OTP already sent. Check your webmail") {
          setSuccessMessage("Otp already sent");
          setTimeout(() => {
            navigate("/register-otp");
            setSuccessMessage("");
          }, 2000);
        } else {
          setSuccessMessage("OTP sent");
          localStorage.setItem("rollNo", rollNo);
          setTimeout(() => {
            setSuccessMessage("");
            navigate("/register-otp");
          }, 2000);
        }
      } else {
        // Handle unexpected 2xx responses

        setError("Server error.Please try again!");
      }
    } catch (error) {
      const errorMessage =
        error.message || // If it's a standard error
        (error.response &&
          error.response.data &&
          error.response.data.message) || // If it contains API response
        "An unexpected error occurred. Please try again."; // Default fallback
      if (errorMessage === "Roll number does not exist in our database") {
        setError("Roll number doesn't exist");
      } else if (
        errorMessage === "Account already exists" ||
        errorMessage === "Invalid roll number"
      ) {
        setError(errorMessage);
      } else {
        setError("Server error.Please try again!");
      }
    }
  };

  return (
    <Container h="100vh" w="100%" mx={0} px={0}>
      <Center h="full">
        <VStack spacing={12}>
          <VStack spacing={[0.1, 0.5, 1]}>
            <Heading fontWeight={700}>Sign Up for Lynx</Heading>
            <Flex direction="row">
              <Text
                color={colors.secondary}
                fontWeight={400}
                fontSize={"0.85em"}
              >
                Already Registered?
              </Text>
              <Box width="3px" />
              <Button
                as="i"
                textDecoration="underline"
                variant="link"
                onClick={() => navigate("/login")}
              >
                <Text
                  color={colors.secondary}
                  fontWeight={400}
                  fontSize={"0.85em"}
                >
                  Login
                </Text>
              </Button>
            </Flex>
          </VStack>
          <VStack spacing={4} w="100%">
            <FormControl>
              <FormLabel>ROLL NUMBER</FormLabel>
              <Input
                pr="4.5rem"
                type="number"
                variant="filled"
                borderRadius="4px"
                onChange={(e) => setRollNo(e.target.value)}
                value={rollNo}
              />
            </FormControl>
            <Button
              w="full"
              colorScheme="brand"
              borderRadius="4px"
              onClick={handleContinue}
            >
              Continue
            </Button>
          </VStack>
        </VStack>
      </Center>
      {error && <ErrorAlert message={error} onClose={() => setError("")} />}
      {successMessage && (
        <SuccessAlert
          message={successMessage}
          onClose={() => setSuccessMessage("")}
        />
      )}
    </Container>
  );
};

const RollScreen = () => {
  const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

  if (!SITE_KEY) {
    // console.error("ReCAPTCHA site key is not defined");
    return null; // Optionally, return a loading state or an error message
  }

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={SITE_KEY}
      scriptProps={{ async: true, defer: true }}
    >
      <Login />
    </GoogleReCaptchaProvider>
  );
};

export default RollScreen;
